import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import axios from "axios";
import VueAxios from "vue-axios";

const actualidad = {
  state: {
    projects: [],
  },
  getters: {
    getProjects: (state) => state.projects,
    getProjectsNotfinish: (state) => {
      /* return state.projects.filter((e) => e.total < e.money_needed); */
      return state.projects.filter((e) => e.complete !== 1);
    },
    getProjectsfinish: (state) => {
      /* return state.projects.filter((e) => e.total < e.money_needed); */
      return state.projects.filter((e) => e.complete === 1);
    },
    findProject: (state) => (slug) => {
      return state.projects.find((e) => e.slug === slug);
    },
  },
  actions: {
    requestProyectos: ({ commit }) => {
      let data = {
        columns: [
          { name: "id" },
          { name: "name" },
          { name: "slug" },
          { name: "visible" },
          { name: "description" },
          { name: "country" },
          { name: "city" },
          { name: "street" },
          { name: "latitude" },
          { name: "longitude" },
          { name: "image" },
          { name: "galery" },
          { name: "money_needed" },
          { name: "added_outside" },
          { name: "created_at" },
          { name: "updated_at" },
          { name: "persons_helped" },
          { name: "objective" },
          { name: "help" },
          { name: "body" },
          { name: "complete" },
          { name: "start_year" },
          { name: "dataId" },
          { name: "manualPaid" },
          { name: "totalPaid" },
          { name: "per" },
        ],
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/projects/paginate`, data)
          .then((response) => {
            commit("setProjects", response.data.data);
            resolve(true);
          })
          .catch((error) => reject(error));
      });
    },
    requestProject: ({ commit }, slug) => {
      let data = {
        columns: [
          { name: "id" },
          { name: "name" },
          { name: "slug" },
          { name: "visible" },
          { name: "description" },
          { name: "country" },
          { name: "city" },
          { name: "street" },
          { name: "latitude" },
          { name: "longitude" },
          { name: "image" },
          { name: "galery" },
          { name: "money_needed" },
          { name: "added_outside" },
          { name: "created_at" },
          { name: "updated_at" },
          { name: "persons_helped" },
          { name: "objective" },
          { name: "help" },
          { name: "body" },
          { name: "complete" },
          { name: "start_year" },
          { name: "dataId" },
          { name: "manualPaid" },
          { name: "totalPaid" },
          { name: "per" },
        ],
        filters: [
          {
            name: "slug",
            search: slug,
          },
        ],
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`/api/projects/paginate`, data)
          .then((response) => {
            resolve(response.data.data[0]);
          })
          .catch((error) => reject(error));
      });
    },
  },
  mutations: {
    setProjects: (state, projects) => {
      state.projects = projects;
    },
  },
};

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/projects.js